export function promisify(fn) {
    return new Promise(function (resolve, reject) {
        try {
            fn(resolve);
        }
        catch (e) {
            reject(e || {});
        }
    });
}
//# sourceMappingURL=promisify.js.map